import axios from "axios";
import { addMessage } from "conten/mensajes/MessagesActions";


import { ofType } from "redux-observable";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { OK, ERROR, apiTimeout } from "config/general/Configuracion";
import {
  GUARDAR_SUSCRIPCION_PLACA,
  guardarSuscripcionPlacaError,
  guardarSuscripcionPlacaSuccess,
  listarPlacasActivasError,
  listarPlacasActivasSuccess,
  listarPlanesActivosError,
  listarPlanesActivosSuccess,
  listarSuscripcionPlacaError,
  listarSuscripcionPlacaSuccess,
  PLACAS_ACTIVAS_LISTAR,
  PLACAS_LISTAR,
  PLAN_LISTAR,
  PLANES_ACTIVOS_LISTAR,
  SUSCRIPCION_PLACA_LISTAR
} from "./SuscripcionPlacaActions";
import SuscripcionPlacaApi from "./SuscripcionPlacaApiClient";

export const listarSuscripcionPlacaEpic = (action$, state$) =>
  action$.pipe(
    ofType(SUSCRIPCION_PLACA_LISTAR),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(SuscripcionPlacaApi.listarSuscripcionPlaca(action.paginacion))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(listarSuscripcionPlacaSuccess(response.data));
                obs.complete();
                action.onSuccess(OK, response.data);
              }
            })
            .catch((error) => {
              obs.next(listarSuscripcionPlacaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const listarPlacasActivasEpic = (action$) =>
  action$.pipe(
    ofType(PLACAS_ACTIVAS_LISTAR),
    mergeMap(() =>
      SuscripcionPlacaApi.listarPlacasActivas()
        .then((response) => listarPlacasActivasSuccess(response.data))
        .catch((error) => listarPlacasActivasError(error))
    )
  );
export const listarPlanesActivosEpic = (action$) =>
  action$.pipe(
    ofType(PLANES_ACTIVOS_LISTAR),
    mergeMap(() =>
      SuscripcionPlacaApi.listarPlanesActivos()
        .then((response) => listarPlanesActivosSuccess(response.data))
        .catch((error) => listarPlanesActivosError(error))
    )
  );

export const guardarSuscripcionPlacaEpic = (action$, state$) =>
  action$.pipe(
    ofType(GUARDAR_SUSCRIPCION_PLACA),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(SuscripcionPlacaApi.guardarSuscripcionPlaca(action.suscripcionPlaca))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(guardarSuscripcionPlacaSuccess(response.data));
                obs.complete();
                action.onSuccess(OK, response.data);
              }
            })
            .catch((error) => {
              obs.next(guardarSuscripcionPlacaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );




